import { Card, Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import { firebase } from "astrid-firebase";
import { DistributionChannel } from "astrid-firestore/src/api/distribution/types/DistributionChannel";
import updateDistributionChannel from "astrid-firestore/src/api/distribution/updateDistributionChannel";

import Form from "../../../../forms/components/Form/Form";
import useSimpleForm from "../../../../forms/hooks/useSimpleForm";
import PrimaryButton from "../../../../ui/components/Buttons/PrimaryButton";
import ErrorMessage from "../../../../ui/components/Messages/ErrorMessage";

export default function SuperAdminDistributionSubChannelsForm({ channel }) {
	const { t } = useTranslation();

	const form = useSimpleForm({
		schema: DistributionChannel,
		defaultValues: {
			subChannels: channel.subChannels || [],
		},
		onSubmit: ({ subChannels }) => {
			return updateDistributionChannel(firebase, { ref: channel.ref, subChannels });
		},
	});

	const { error, formState, onSubmit } = form;

	return (
		<>
			<Header as="h3">{t("subChannels", "Sub channels")}</Header>

			<Card fluid>
				<Card.Content>
					<Form form={form}>
						{" "}
						<Form.FormFieldArrayTable name="subChannels" header={t("subChannels", "Sub channels")}>
							{({ id, name }, index) => (
								<Form.Group widths="equal" style={{ margin: 0 }}>
									<Form.Input
										name={`subChannels.${index}.id`}
										value={id}
										placeholder={t("id", "Id")}
									/>
									<Form.Input
										name={`subChannels.${index}.name`}
										value={name}
										placeholder={t("name", "Name")}
									/>
								</Form.Group>
							)}
						</Form.FormFieldArrayTable>
					</Form>

					{error && <ErrorMessage error={error} />}
				</Card.Content>

				<Card.Content>
					<PrimaryButton
						disabled={formState.isSubmitting || !formState.isDirty}
						loading={formState.isSubmitting}
						onClick={onSubmit}
					>
						{t("save", "Save")}
					</PrimaryButton>
				</Card.Content>
			</Card>
		</>
	);
}
